import { render, staticRenderFns } from "./fulfillmentConfirm.vue?vue&type=template&id=dd5763ae&scoped=true"
import script from "./fulfillmentConfirm.vue?vue&type=script&lang=js"
export * from "./fulfillmentConfirm.vue?vue&type=script&lang=js"
import style0 from "./fulfillmentConfirm.vue?vue&type=style&index=0&id=dd5763ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5763ae",
  null
  
)

export default component.exports